
import { ref } from '@vue/composition-api';
import Fuse from 'fuse.js';
import type Brand from '~/type/Brand';
import type BrandGroup from '~/type/BrandGroup';
interface Options {
  includeScore: boolean;
  threshold: number;
  location: number;
  distance: number;
  maxPatternLength: number;
  minMatchCharLength: number;
  keys: string[];
}
const __sfc_main = {};
__sfc_main.props = {
  options: {
    key: "options",
    required: true,
    type: null
  },
  list: {
    key: "list",
    required: true,
    type: Array
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const text = ref('');
  let data: Brand[];
  function onFocus() {
    if (!data) {
      data = props.list.reduce((accumulator: Brand[], currentValue) => {
        currentValue.list.forEach(elem => {
          accumulator.push(elem);
        });
        return accumulator;
      }, []);
    }
    return new Fuse(data, props.options);
  }
  function searchResult() {
    /**
    * Срабатывает при вводе текста в input
    */
    emit('search-result', onFocus().search(text.value));
    /**
    * Срабатывает при вводе текста в input
    */
    emit('input', text.value);
  }
  return {
    text,
    onFocus,
    searchResult
  };
};
export default __sfc_main;
